<template>
  <div class="tunnel-box">
    <div class="tunnel-bg">
      <img src="@/assets/images/couponTunnel/appbg.png" alt="">
    </div>
    <div class="tunnel-content">
      <div class="coupon-list">
        <coupon-list :couponList="couponList" @getCoupon="getCoupon"></coupon-list>
      </div>
      <div class="rule-box">
        <p class="rule-title">活动细则：</p>
        <p class="rule-item">(1)领取优惠券后，您可在优惠券中心进行查看；</p>
        <p class="rule-item">(2)每次通行只可使用1张优惠券；</p>
        <p class="rule-item">(3)隧道优惠券有效时长7天；</p>
        <p class="rule-item">(4)优惠券数量有限，发完即止；</p>
        <p class="rule-item">(5)优惠券不兑现、不找零、不开具发票。</p>
      </div>
      <div class="ad-box">
        <img @click="goAd" src="@/assets/images/couponTunnel/banner.png" alt="">
      </div>
      <van-popup class="custom-popup" v-model="showResult" round>
        <div class="result-box">
          <div class="desc">{{statusText}}</div>
          <div class="btn-box">
            <!-- <button class="btn btn-cancel" @click="handleCancel">取消</button> -->
            <button class="btn" @click="handleCancel">确定</button>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
import { Toast, Popup } from 'vant'
import { listCoupon, getItemCoupon } from '@/api/couponTunnel'
import couponList from './couponList.vue'
import { setStore } from '@/utils/index'
export default {
  components: {
    [Popup.name]: Popup,
    couponList
  },
  data () {
    return {
      activityId: null,
      showResult: false,
      statusText: '',
      couponList: []
    }
  },
  created () {
    const token = this.$route.query.token
    this.activityId = this.$route.query.activityId
    if (token) {
      console.log(token)
      setStore('token', token)
    }
    if (this.activityId) {
      this.getList()
    }
  },
  methods: {
    getList () {
      const requestData = {
        activityId: this.activityId,
        getStateFlag: 1
      }
      listCoupon(requestData).then((res) => {
        if (res.data.code === 200) {
          this.couponList = res.data.result || []
        } else {
          Toast({
            message: res.data.message
          })
        }
      })
    },
    goAd () {
      const data = {
        androidGoPage: '/ReactNative/QDTActiveActivity',
        iosGoPage: 'QDTViewController',
        appType: 0,
        appStartUrl: 'CarbonEnergyHomePage'
      }
      dsBridge.call('callNativeViewLifeCycle', {
        androidGoPage: data.androidGoPage,
        iosGoPage: data.iosGoPage,
        appType: data.appType,
        appStartUrl: data.appStartUrl,
        authorize: 0,
        addToolbar: 1
      })
    },
    // 领劵
    getCoupon (item) {
      const requestData = {
        activityId: this.activityId,
        batchId: item.batchId
      }
      this.loading = true
      getItemCoupon(requestData).then((res) => {
        this.loading = false
        if (res.data.code === 200) {
          if (res.data.result) {
            const state = res.data.result.state
            this.statusText = this.formatStatus(state)
            this.showResult = true
            this.getList()
          }
        }
      }).catch((e) => {
        this.loading = false
      })
    },
    formatStatus (status) {
      switch (+status) {
        case 0: return '恭喜您领取成功，快去使用吧~'
        case 1: return '您已经领过了，快去使用吧~'
        case 2: return '优惠券领光了'
        case 3: return '该活动已结束，领取更多优惠，请到便捷青岛APP-领券中心'
        case 4: return '活动未开始，请耐心等待'
        default: return null
      }
    },
    handleCancel () {
      this.showResult = false
    }
  }
}
</script>
<style lang='scss' scoped>
.tunnel-box {
  position: relative;
}
.ad-box {
  margin: 20px;
  img {
    width: 100%;
    max-height: 200px;
  }
}
.tunnel-bg{
 img {
   width: 100%;
 }
}
.tunnel-content {
  position: absolute;
  width: 100%;
  top: 63%;
}
.rule-box {
  padding: 15px 2% 15px 8%;
  font-size: 13px;
  line-height: 1.8;
}
.custom-popup {
  width: 70%;
  padding: 30px 20px 15px;
  border-radius: 8px;
  font-size: 15px;
  color: #6D7278;
}
.result-box {
  .desc {
    text-align: center;
  }
}
.btn-box {
  display: flex;
  justify-content: center;
  .btn {
    width: 80%;
    margin: 40px 10px 10px;
    padding: 8px;
    border: none;
    outline: none;
    color: #fff;
    font-size: 14px;
    border-radius: 30px;
    background: #F14950;
  }
  .btn-cancel {
    background: #F6F8FA;
    color: #B4C0CB;
  }
  .btn-block {
    width: 90%;
  }
}
</style>
